<template>
  <div class="card-list-item product-item clickable" @click="itemClick()">
    <div class="card-item-main-wrap">
      <div class="card-item-main">
        <div class="card-item-image" v-if="false && product.file_id" :style="{ backgroundImage: 'url('+productImage+')'}"></div>
        <div :class="'card-item-title product-item-title' + (false && product.file_id ? ' has-image' : ' no-image')">
          <div class="card-item-name-wrap"><span class="card-item-name product-item-name">{{ $filters.marketingname(product) }}</span></div>
          <div class="card-item-description" v-html="product.description"></div>
          <div class="card-item-tags" v-if="tags.length">
            <span class="label label-info" v-for="tag in tags">{{ tag }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>

import errors from '~/lib/errors'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      productCount: 1
    }
  },
  mixins: [ errors ],
  props: ['product', 'productShopId', 'baseDomain', 'settings'],
  computed: {
    ...mapGetters(['version', 'locale']),
    productImage () {
      return (this.product.file_id ? this.baseDomain + this.productShopId + '/files/' + this.product.file_id + '.' +this.product.file_ext : 'data:image/gif;base64,R0lGODlhDwAKAJEAAAAAAP///////wAAACH5BAEHAAIALAAAAAAPAAoAAAIKlI+py+0Po5xUFgA7')
    },
    tags () {
      let tagNames = []
      if (this.settings && this.product && this.product.sharedTag && this.product.sharedTag.length) {
        let tagArray = this.product.sharedTag
        for (let i = 0; i < tagArray.length; i++) {
          let defaultTagParts = tagArray[i].title.split(':::')
          let tagParts = tagArray[i].title.split(':::' + this.locale + ':::') 
          if (this.locale === this.settings.defaultversion && defaultTagParts.length === 2 && defaultTagParts[0] === 'product') {
            tagNames.push(defaultTagParts[1])
          } else if(tagParts.length == 2 && tagParts[0] === 'product') {
            tagNames.push(tagParts[1]) 
          }
        }
      }
      return tagNames
    }
  },
  methods: {
    itemClick() {
        this.$emit('itemClick', this.product.id)
    }
  }
}
</script>